import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
} from "@mui/material";
import {
  getApiCall,
  postApiCall,
  postFormApiCall,
} from "../../../../utils/api";
import Swal from "sweetalert2";

const Individual = ({ setIsOpen, fetchData }) => {
  const [formData, setFormData] = useState({
    school_id: "",
    image: "",
    name: "",
    class: "",
    parent_name: "",
    phone: "",
    email: "",
    role: "admin",
  });

  const classes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const [loading, setLoading] = useState(false);
  const [schoolData, setSchoolData] = useState([]);

  useEffect(() => {
    // setStudentData([])
    fetchDataInit();
  }, []);
  const fetchDataInit = async () => {
    setLoading(true);
    const res = await getApiCall("admin/get-all-schools");

    setSchoolData(res.data);
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default HTML form submission behavior

    const res = await postApiCall("student/register-invite-students", {
      bulk_student_upload_data: [formData],
    });

    if (res.success === false) {
      if (setIsOpen) setIsOpen(false);

      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });
    fetchData();

    if (setIsOpen) setIsOpen(false);
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      school_id: "",
      class: "",
      parent_name: "",
      phone: "",
      email: "",
      role: "",
    });
    if (setIsOpen) setIsOpen(false);
  };

  return (
    <div>
      {loading == true ? (
        "Loading......."
      ) : (
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            backgroundColor: "#fff4e6",
            borderRadius: 2,
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <FormControl fullWidth required>
            <InputLabel>School</InputLabel>
            <Select
              name="school_id"
              value={formData.school_id}
              onChange={handleChange}
              label="School"
              displayEmpty
              required
            >
              <MenuItem value="" disabled>
                Select School
              </MenuItem>
              {schoolData.map((cls) => (
                <MenuItem key={cls.id} value={cls.id}>
                  {cls.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            required
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Add Student name"
            fullWidth
          />

          <FormControl fullWidth required>
            <InputLabel>Class</InputLabel>
            <Select
              name="class"
              value={formData.class}
              onChange={handleChange}
              label="Class"
              displayEmpty
              required
            >
              <MenuItem value="" disabled>
                Select Class
              </MenuItem>
              {classes.map((cls) => (
                <MenuItem key={cls} value={cls}>
                  {cls}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Parent Name"
            name="parent_name"
            value={formData.parent_name}
            onChange={handleChange}
            placeholder="Add Parent's Name"
            fullWidth
          />

          <TextField
            label="Phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Add Parent’s phone number"
            fullWidth
          />

          <TextField
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Add Student Email"
            fullWidth
          />

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}
          >
            <Button
              variant="outlined"
              color="secondary"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button variant="contained" color="primary" type="submit">
              Submit
            </Button>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default Individual;
